import Model from '@/models/Model'

export default class GBank extends Model {
    resource() {
        return 'g_bank'
    }
    toCreate() {
      return this.clean([
        'code',
        'bank',
      ])
    }
    toUpdate() {
      return this.clean([
        'id',
        'code',
        'bank',
      ])
    }
}